import styled from 'styled-components';

export const SettingsButtonContainer = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`;
